import { Button, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const TransactionButton = ({
  children,
  variant = 'buy',
  disabled = false,
  onClick,
  size = 'medium',
  width = '60%',
  boxSx = {},
  ...props
}) => {
  const theme = useTheme();

  const variantColors = {
    buy: {
      bg: 'rgba(3, 200, 104, 1)',
      text: '#fff',
    },
    emit: {
      bg: theme.primary,
      text: theme.text1 || '#fff',
    },
    reserve: {
      bg: theme.primary,
      text: theme.text1 || '#fff',
    },
  };

  const sizeStyles = {
    small: {
      padding: '4px 12px',
      fontSize: '12px',
      borderRadius: '8px',
      height: '30px',
    },
    medium: {
      padding: '4px 16px',
      fontSize: '18px',
      borderRadius: '8px',
      height: '42px',
    },
    large: {
      padding: '10px 24px',
      fontSize: '18px',
      borderRadius: '8px',
      height: '50px',
    },
  };

  const { bg, text } = variantColors[variant];
  const { padding, fontSize, borderRadius, height } =
    sizeStyles[size] || sizeStyles.medium;

  const baseStyles = {
    padding,
    fontWeight: 600,
    borderRadius,
    fontSize,
    marginTop: '5px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width,
    whiteSpace: 'nowrap',
    backgroundColor: bg,
    height,
    color: text,
    '&:hover': {
      backgroundColor: alpha(bg, 0.85),
      fontWeight: 700,
    },
    '&.Mui-disabled': {
      backgroundColor: '#dfdfdf',
      color: '#aaa',
    },
    ...boxSx,
  };

  return (
    <Button sx={baseStyles} disabled={disabled} onClick={onClick} {...props}>
      {children}
    </Button>
  );
};

export default TransactionButton;
